import { Component, HostListener, Inject, OnInit, TemplateRef, ViewChild, DOCUMENT } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AtsResumeScreenService } from "../_services/ats-resume-screen.service";
import { UnifiedService } from "../unified/unified.service";
import { LocalStorageService } from "../_services/local-storage.service";
import { IUnifiedIntegration } from "../unified/unified.types";
import { BulkUploadResumeModelComponent } from "./bulk-resume-upload-model/bulk-upload-resume-model.component";
import { finalize, switchMap } from "rxjs/operators";

import { PersonSearchService } from "../_services/person-search.service";

@Component({
    selector: 'app-resume-screen',
    templateUrl: './resume-screen.component.html',
    styleUrls: ['./resume-screen.component.scss'],
    standalone: false
})

export class ResumeScreenComponent implements OnInit {


  @ViewChild('renameProjectModel') renameProjectModel: TemplateRef<any>;
  @ViewChild('handleBackEventModel') handleBackEventModel: TemplateRef<any>;
    @ViewChild('importJobsModel') importJobsModel: TemplateRef<any>;

    jobsList: any[] = [];
    modelJobsListDetails: any = {};
    modelJobsList: any[] = [];
    logo: string = '';

    startScreeningSelectedJobid: string | null = null;
    startScreeningLoader: boolean = false;

    searchInput: UntypedFormControl = new UntypedFormControl(null);
    typeAheadData: any[] = [];
    isTeamAdmin: boolean = false;

    /** Pagination handler */
    start: number = 0;
    limit: number = 10;
    currentPage: number = 1;
    profilesPerPage: number = 10
    totalCount: number = 0;

    successMessage: String = '';
    errorMessage: String = '';
    infoMessage: string = '';

    showSpinnerLoader: Boolean = false;
    importJobLoader: boolean = false;
    importJobListLoader: boolean = false;

    selectedJobIdForImport: string | null = null;

    /** Regex to check valid jobs name */
    inputRegex = /^[a-zA-Z0-9\-'\.,@&\/\+\:\#_\(\)\"\'\* ]*$/;

    /** Available integration variable */
    availableIntegrations: (IUnifiedIntegration & { user: null | { enabled: boolean, connection_id: string }, processing: boolean })[] = [];


    showSubmitJdSpinner: boolean = false;
    jdInput: UntypedFormControl = new UntypedFormControl(null);
    jdInputError: boolean = false;

    jobCreatedTab: boolean = false;
    jobImportedTab: boolean = true;
    selectedRenameProject: any;
    projectDescription:any;
    targetIndustries:any;
    projectSkills:any;
    renameProjectInput: UntypedFormControl = new UntypedFormControl(null);
    renameProjectInputError: Boolean = false;
    renameProjectInputSpecialCharError: Boolean = false;

    isScrolled: boolean = false;
    private readonly scrollThreshold = 55;
    @HostListener('window:scroll', ['$event'])
    onWindowScroll() {
        const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.isScrolled = verticalOffset >= this.scrollThreshold;
    };

    constructor(
        private modelService: NgbModal,
        private router: Router,
        private atsResumeScreenService: AtsResumeScreenService,
        private unifiedService: UnifiedService,
        private localStorageService: LocalStorageService,
        private personSearchService: PersonSearchService,
        @Inject(DOCUMENT) private document: Document
    ) {

    }

    ngOnInit(): void {
        const preferenceArray = this.localStorageService.getItem('userdata').preferenceData;
        // check if the user is a team admin
        this.isTeamAdmin = !!this.localStorageService.getItem('isteamAdmin');
        preferenceArray && preferenceArray.length && preferenceArray.map((item: any) => {
            if (item.listing_type == 'screenai-job-listing' && item.preference_type == 'page-size') {
                this.profilesPerPage = item.preference_value;
            }
        })

        this.searchInput.valueChanges.subscribe((value: string) => {
            this.start = 0;
            this.currentPage = 1;
            if (value && value.trim()) {
                this.getJobsList(this.jobImportedTab ? 'import' : 'create');
            } else {
                this.getJobsList(this.jobImportedTab ? 'import' : 'create');
            }
        });
        this.getJobsList(this.jobImportedTab ? 'import' : 'create');

        this.getATSConnectedDetails();

    };

    /**
     * Get connected ats details
     */
    getATSConnectedDetails() {
        this.unifiedService.getUserUnifiedIntegrations('', true).subscribe((integrations: any) => {
            if (integrations.status == 'success') {
                this.availableIntegrations = integrations.data;
            }
        });

    };

    onTabChanges(tabname: string) {
        this.searchInput.setValue(null);
        if (tabname == 'createdTab') {
            this.jobCreatedTab = true;
            this.jobImportedTab = false;
            this.getJobsList('create');

        } else if (tabname == 'importedTab') {
            this.jobImportedTab = true;
            this.jobCreatedTab = false;
            this.getJobsList('import');
        }
    };



    /**
     * Method to fetch all the imported jobs
     */
    getJobsList(tabname?: string) {
        const data = {
            search: this.searchInput.value,
            source: tabname,
            start: this.start,
            limit: this.profilesPerPage
        }
        this.atsResumeScreenService.getJobsList(data).subscribe((response: any) => {
            if (response && response.success) {
                this.totalCount = response.data?.total;
                this.jobsList = response.data?.jobs;
            } else {
                this.totalCount = 0;
                this.jobsList = [];
            }
            this.startScreeningLoader = false;
            setTimeout(() => {
            }, 500);
        })
    };


    /**
    * Method to fetch all the imported jobs
    */
    startScreening(job: any) {

        if (job?.source == 'create' && job?.application_count) {
            this.router.navigate([`/resume-screen/candidate-listing/${job.ats_job_id}`])
        } else if (job?.source == 'create' && !job?.application_count) {
            this.router.navigate([`/resume-screen/upload-resume/${job.ats_job_id}`])
        } else {
            const payload = {
                jobId: job.unified_job_id,
                type: "on-demand",
                source: job.source ? job.source : 'create'
            }
            this.startScreeningSelectedJobid = job.ats_job_id;
            this.startScreeningLoader = true;

            this.atsResumeScreenService.startScreening(payload).pipe(
                switchMap((response: any) => {
                 
                    const currentTab = this.jobCreatedTab ? 'create' : 'import';
                    return this.atsResumeScreenService.getJobsList({
                        search: this.searchInput.value,
                        source: currentTab
                    });
                }),
                finalize(() => {
                    this.startScreeningLoader = false;
                    this.startScreeningSelectedJobid = null;
                })
            ).subscribe(
                (response: any) => {
                    if (response?.success) {
                        this.totalCount = response.data?.total;
                        this.jobsList = response.data?.jobs;
                    } else {
                        this.totalCount = 0;
                        this.jobsList = [];
                    }
                },
                () => {
                    this.errorMessage = 'Something went wrong!';
                    setTimeout(() => this.errorMessage = '', 3000);
                }
            );

        }
    };




    /**
     * Open model for the job creation
     */
    createJob() {
        this.localStorageService.clearItem('jobdetails');
        this.router.navigate([`/resume-screen/create-job`]);
    };

    /**
     * Open model for the job creation
     */
    connectATS() {
        this.router.navigate([`/settings/ats-integrations/ats`]);
    };

    /**
     * Method to handle the renaming of a project.
     */
    openJobListModel() {
        this.modelJobsList = [];
        this.getImportJobsList();
        this.modelService.open(this.importJobsModel, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    };

    /**
     * Get import model project list
     * @returns
     */
    getImportJobsList() {
        this.importJobListLoader = true;
        this.atsResumeScreenService.getModelJobsList().subscribe((res: any) => {
            if (res && res.success) {
                this.modelJobsListDetails = res.data;
                this.modelJobsList = res.data?.jobs
                this.logo = res?.data?.logo;
            } else {
                this.modelJobsListDetails = {};
                this.modelJobsList = [];
                this.logo = '';
            }
            this.importJobListLoader = false;
        }, (err) => {
            this.modelJobsListDetails = {};
            this.modelJobsList = [];
            this.logo = '';
            this.importJobListLoader = false;
        })
    }

    /**
     * Method to fetch all the imported jobs
     */
    importJobDetails(jobid: string) {
        this.localStorageService.clearItem('jobdetails');
        this.importJobLoader = true;
        this.selectedJobIdForImport = jobid;

        this.atsResumeScreenService.getJobDetails(jobid).subscribe((response: any) => {
            if (response && response.success) {
                this.localStorageService.setItem('jobdetails', JSON.stringify({...response, calledfrom: 'job-imports'}));
                this.dismiss();
                this.router.navigate([`/resume-screen/create-job`]);
            } else {
                this.errorMessage = 'Something went wrong!';
                setTimeout(() => { this.errorMessage = ''; }, 3000);
            }
            this.importJobLoader = false;
            this.selectedJobIdForImport = null;
        })
    };

    /**
     * Upload resume while job is a create
     */

    uploadCandidate(jobid: string) {
        this.router.navigate([`/resume-screen/candidate-listing/${jobid}`], { queryParams: { upload: true } });        

        // const modalRef = this.modelService.open(BulkUploadResumeModelComponent, { size: 'md' as 'md', centered: true, backdrop: 'static', keyboard: false });
        // modalRef.componentInstance.id = jobid;
        // modalRef.componentInstance.event.subscribe((res: any) => {
        //     if (res.status == 'success') {
        //         this.successMessage = 'Resume uploaded successfully!';
        //         setTimeout(() => { this.successMessage = ''; }, 3000);
        //         this.modelService.dismissAll();
        //         this.router.navigate([`/resume-screen/candidate-listing/${jobid}`]);
        //     } else if (res.status == 'cancel') {
        //         this.modelService.dismissAll();
        //     } else { 
        //         this.errorMessage = 'Something went wrong, Please try agian!';
        //         setTimeout(() => { this.errorMessage = ''; }, 3000);
        //         this.modelService.dismissAll();
        //     }
        // });
    };


    /**
     * Handle view candidate redirection
     */
    viewCandidates(job: any) {
        this.router.navigate([`/resume-screen/candidate-listing/${job.ats_job_id}`]);
    };

    /**
     * Handle redirection while clicking on job name
     * @param job
     */
    handleRedirect(job: any) {
        this.router.navigate([`/resume-screen/candidate-listing/${job.ats_job_id}`]);

        // if (job?.source == 'create') {
        //     if (job?.groq_status == 'completed') {
        //         this.router.navigate([`/resume-screen/candidate-listing/${job.ats_job_id}`]);
        //     } else if (job?.groq_status == 'pending') {
        //         this.router.navigate([`/resume-screen/candidate-listing/${job.ats_job_id}`]);
        //     } else {
        //         this.router.navigate([`/resume-screen/upload-resume/${job.ats_job_id}`]);
        //     }
        // } else if (job?.source == 'import') {
        //     if (job?.sync_status == 'completed' && job?.groq_status == 'completed') {
        //         this.router.navigate([`/resume-screen/candidate-listing/${job.ats_job_id}`]);
        //     } else if ((job?.sync_status && job?.sync_status != 'completed') || (job?.groq_status && job?.groq_status != 'completed')) {
        //         this.router.navigate([`/resume-screen/candidate-listing/${job.ats_job_id}`]);
        //     } else {
        //         this.router.navigate([`/resume-screen/upload-resume/${job.ats_job_id}`]);
        //     }
        // } else {

        // };
    };


    /**
     * Method to handle the dismissal of the project list component.
     */
    dismiss() {
        this.modelService.dismissAll();
        this.showSpinnerLoader = false;
        this.importJobLoader = false;
        this.selectedJobIdForImport = null;
    }
    /**
   * Method to handle the renaming of a project.
   */
  openRenameProjectModel(project: any) {
    this.selectedRenameProject = project;
    this.renameProjectInput.setValue(project?.name ? project?.name : null);
    this.modelService.open(this.renameProjectModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };

    /**
   * Rename Job Name
   * @returns
   */
  renameProject() {
    if ((!this.renameProjectInput.value && !this.selectedRenameProject?.ats_job_id) || this.renameProjectInputSpecialCharError) return;
    this.showSpinnerLoader = true;
    const jobName = {
      name: this.renameProjectInput.value.trim()
    };
    const jobId = this.selectedRenameProject?.ats_job_id;

    this.atsResumeScreenService.renameJob(jobId, jobName).subscribe((res: any) => {
      if (res && res.body && res.body.status == 'success') {
        this.successMessage = res.body.message;
        this.getJobsList('create');
        this.renameProjectInput.setValue(null);
        this.renameProjectInputError = false;
        this.selectedRenameProject = null;
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = res.body.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.dismiss();
      this.showSpinnerLoader = false;
    }, (err) => {
      this.errorMessage = err.error.message;
      setTimeout(() => this.errorMessage = '', 5000);
      this.showSpinnerLoader = false;
    })
  }

    isScreeningInProgress(job: any): boolean {
        return (
            job?.sync_status === 'in-progress' ||
            job?.groq_status === 'pending' ||
            (job?.sync_status === 'in-progress' && job?.groq_status === 'failed') ||
            (job?.sync_status === 'completed' && job?.groq_status === 'pending')
        );
    }

    showRunButton(job: any): boolean {
        return (
            !this.isScreeningInProgress(job) &&
            !(job?.sync_status === 'completed' && job?.groq_status === 'completed')
        );
    }

    get screeningTooltip(): string {
        if (!this.isTeamAdmin) {
            return 'You don\'t have permission to import jobs from ATS';
        }
        if (!this.availableIntegrations?.length) {
            return 'Please connect your ATS';
        }
        return '';
    }

    getRunButtonText(job: any): string {
        if (!job?.sync_status && !job?.groq_status) {
            return 'Run Screen AI';
        }
        return 'Re Run';
    }

    /**
     * Method to handle pagination
     * @param index 
     */
    setPage(index: number) {
        this.start = (index - 1) * Number(this.profilesPerPage);
        if (index == 1) this.currentPage = 1;
        this.getJobsList();
        this.document.documentElement.scrollTop = 0;
    };

    /**
    * Used to change number of profiles on each page
    */
    updatePagePreference() {
        const data = {
            preference_type: 'page-size',
            preference_value: this.profilesPerPage,
            listing_type: 'screenai-job-listing'
        }

        try {
            this.personSearchService.updatePagePreference(data);
            this.setPage(1);
        } catch {
            this.errorMessage = "Something went wrong";
            setTimeout(() => this.errorMessage = '', 5000);
        }
    };
}
